






import { useEffect, useState } from "react";
import { adminDailyAttendanceApi } from "../../../app/api";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createPortal } from "react-dom";

 
export default function MyAttendance() {
 
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
 
  const [sortBy, setSortBy] = useState("");

  useEffect(() => {
    setCurrentPage(1);
  }, [sortBy, selectedDate]);
  const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
  const navigate = useNavigate();
 
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState(null);
 
  const fetchAttendance = (date) => {
    setLoading(true);
 
    adminDailyAttendanceApi(date)
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) {
          setRecords(res.data);
        } else {
          setRecords([]);
        }
      })
      .catch(() => setRecords([]))
      .finally(() => setLoading(false));
  };
 
  useEffect(() => {
    if (selectedDate) {
      const formatted = selectedDate.toISOString().split("T")[0];
      fetchAttendance(formatted);
    }
  }, [selectedDate]);

  useEffect(() => {
    const handleAttendance = () => {
      if (selectedDate) {
        const formatted = selectedDate.toISOString().split("T")[0];
        fetchAttendance(formatted);
      }
    };
    window.addEventListener("attendance-updated", handleAttendance);
    return () => {
      window.removeEventListener("attendance-updated", handleAttendance);
    };
  }, [selectedDate]);
 
  if (loading) {
    return (
      <div className="p-6 text-center text-gray-400">
        Loading attendance...
      </div>
    );
  }
 
  const getTotalMinutes = (row) => row.total_minutes || 0;
  const getBreakMinutes = (row) => row.break_minutes || 0;
 
  const getPunchInSeconds = (time) => {
    if (!time) return 0;
    const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };
 
  const sortedRecords = [...records].sort((a, b) => {
 
    if (!sortBy) {
      return (a.name || "")
        .toLowerCase()
        .localeCompare((b.name || "").toLowerCase());
    }
 
    let result = 0;
 
    if (sortBy === "HOURS") {
      result = getTotalMinutes(b) - getTotalMinutes(a);
    }
 
    if (sortBy === "BREAK") {
      result = getBreakMinutes(b) - getBreakMinutes(a);
    }
 
    if (sortBy === "LATE") {
      result = getPunchInSeconds(a.punch_in) - getPunchInSeconds(b.punch_in);
    }
 
    if (result === 0) {
      return (a.name || "")
        .toLowerCase()
        .localeCompare((b.name || "").toLowerCase());
    }
 
    return result;
  });
 
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
 
  const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);
 
  return (
    <>
 
          
          <div className="max-w-7xl mx-auto md:mt-8 mt-6">
      <div className="
        relative
        overflow-hidden
        rounded-[30px]
        p-8
        bg-[#12082F]
        shadow-[0_20px_60px_rgba(0,0,0,0.6)]
        text-white
        border border-white/10
        shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
      ">
          
          {/* HEADER */}
 
          <div className="flex flex-wrap items-center justify-between mb-6 gap-2 md:gap-4">
 
            <h2 className="text-white text-lg font-semibold ">
              All Users Attendance ({selectedDate?.toISOString().split("T")[0]})
            </h2>
 
            {/* <div className="flex flex-col md:flex-row items-center gap-3"> */}
 
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="
                 px-2 py-1 text-sm rounded-[10px]
                bg-white/10 text-white
                border border-white/20
                shadow-lg focus:outline-none
                backdrop-blur-md outline-none
                cursor-pointer
                "
              >
                <option className="text-black" value="">Sort By</option>
                <option className="text-black" value="HOURS">Total Working Hours</option>
                <option className="text-black" value="BREAK">Total Break Duration</option>
                <option className="text-black" value="LATE">Punch-In Time</option>
              </select>



              <div className="flex flex-row md:flex-row items-center gap-3">

              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="yyyy-MM-dd"
                className=" px-2  py-1 text-sm rounded-[10px]
                bg-white/10 text-white
                border border-white/20
                shadow-lg focus:outline-none
                backdrop-blur-md outline-none
                cursor-pointer"
              />
 
              <button
                onClick={() => setSelectedDate(new Date())}
                className="bg-white/10 text-white  px-2  py-1 text-sm rounded-[10px] border border-white/10   hover:bg-white/20 transition"
              >
                Reset
              </button>
 
            </div>
          </div>
 
          {/* TABLE */}
 
          <div className="overflow-x-auto rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl">
            <table className="min-w-[900px] w-full text-sm text-white">
 
              <thead>
                <tr className="text-xs uppercase tracking-wider text-gray-300 border-b border-white/10">
                  <th className="p-4 text-left">Name</th>
                  <th className="p-4 text-left">Punch In</th>
                  <th className="p-4 text-left">Image In</th>
                  <th className="p-4 text-left">Image Out</th>
                  <th className="p-4 text-left">Punch Out</th>
                  <th className="p-4 text-left">Total Hours</th>
                  <th className="p-4 text-left">Break</th>
                  <th className="p-4 text-left">Status</th>
                  <th className="p-4 text-left">Early / Extra</th>
                </tr>
              </thead>
 
              <tbody>
 
                {records.length > 0 ? (
 
                  currentRecords.map((row, i) => (
 
                    <tr
                      key={row.user_id || i}
                      className="border-b border-white/5 hover:bg-white/10 transition"
                    >
 
                      {/* NAME */}
 
                      <td className="p-4 whitespace-nowrap">
 
                        <div
                          className="flex items-center gap-3 cursor-pointer"
                          onClick={() => navigate(`/users/${row.user_id}`)}
                        >
 
                          <div className="w-9 h-9 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-white font-semibold">
 
                            {row.profile_pic ? (
                              <img
                                src={`${IMAGE_BASE_URL}${row.profile_pic}`}
                                className="w-full h-full rounded-full object-cover"
                                alt="profile"
                              />
                            ) : (
                              row.name?.charAt(0) || "U"
                            )}
 
                          </div>
 
                          <p className="font-medium hover:text-cyan-400 hover:underline">
                            {row.name || "—"}
                          </p>
 
                        </div>
 
                      </td>
 
                      <td className="p-4">{row.punch_in || "—"}</td>
 
                      <td className="p-4">
                        {row.punch_in_img ? (
                          <img
                            src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
                            className="w-10 h-10 rounded cursor-pointer"
                            onClick={() =>
                              setImagePreview(`${IMAGE_BASE_URL}/${row.punch_in_img}`)
                            }
                          />
                        ) : "—"}
                      </td>
 
                      <td className="p-4">
                        {row.punch_out_img ? (
                          <img
                            src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
                            className="w-10 h-10 rounded cursor-pointer"
                            onClick={() =>
                              setImagePreview(`${IMAGE_BASE_URL}/${row.punch_out_img}`)
                            }
                          />
                        ) : "—"}
                      </td>
 
                      <td className="p-4">{row.punch_out || "—"}</td>
 
                      <td className="p-4">
 
                        {row.total_minutes
                          ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
                          : "—"}
 
                      </td>
 
                      {/* <td className="p-4">
 
                        {Number(row.break_minutes) === 0
                          ? <span className="text-gray-400">Not taken</span>
                          : `${row.break_minutes}m`}
 
                      </td> */}
 
 
<td className="p-4">
 
  {row.break_status === 1 ? (
    <span className="text-yellow-400 font-medium">
      On Break
    </span>
  ) : Number(row.break_minutes) === 0 ? (
    <span className="text-gray-400">Not taken</span>
  ) : (
    `${row.break_minutes}m`
  )}
 
</td>
 
 
 
                      <td className="p-4">
 
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-medium flex items-center w-fit
                          ${row.status
                              ? "bg-emerald-500/20 text-emerald-400"
                              : "bg-red-500/20 text-red-400"
                            }`}
                        >
                          {row.status ? "Present" : "Absent"}
                        </span>
 
                      </td>
 
                      <td className="p-4 text-xs">
 
                        Early: {row.early_time || "0m"} <br />
                        Extra: {row.extra_time || "0m"}
 
                      </td>

                    </tr>
 
                  ))
 
                ) : (
 
                  <tr>
                    <td colSpan="10" className="text-center p-6 text-gray-400">
                      No Attendance Records Found
                    </td>
                  </tr>
 
                )}
 
              </tbody>
            </table>
          </div>
 
          {/* PAGINATION */}
 
          {totalPages > 1 && (
            <div className="flex justify-center mt-6 items-center gap-4">
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 rounded-xl text-sm transition bg-white/10 text-white hover:bg-white/20 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Prev
              </button>
              <span className="text-sm text-white/90 font-medium">
                Page {currentPage} of {totalPages}
              </span>
              <button
                 onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                 disabled={currentPage === totalPages}
                 className="px-4 py-2 rounded-xl text-sm transition bg-white/10 text-white hover:bg-white/20 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          )}
 
        </div>
      </div>
 
      {/* IMAGE MODAL */}
 
      {imagePreview && createPortal(
 
        <div
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
          onClick={() => setImagePreview(null)}
        >
 
          <div className="bg-white p-4 rounded-xl">
            <img src={imagePreview} className="max-h-[80vh]" />
          </div>
 
        </div>,
document.body
 
      )}
 
    </>
  );
}






// import { useEffect, useState } from "react";
// import { adminDailyAttendanceApi } from "../../../app/api";
// import { useNavigate } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
 
// export default function MyAttendance() {
 
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [currentPage, setCurrentPage] = useState(1);
//   const recordsPerPage = 5;
 
//   const [sortBy, setSortBy] = useState("");

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [sortBy, selectedDate]);
//   const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
//   const navigate = useNavigate();
 
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imagePreview, setImagePreview] = useState(null);
 
//   const fetchAttendance = (date) => {
//     setLoading(true);
 
//     adminDailyAttendanceApi(date)
//       .then((res) => {
//         if (res?.success && Array.isArray(res.data)) {
//           setRecords(res.data);
//         } else {
//           setRecords([]);
//         }
//       })
//       .catch(() => setRecords([]))
//       .finally(() => setLoading(false));
//   };
 
//   useEffect(() => {
//     if (selectedDate) {
//       const formatted = selectedDate.toISOString().split("T")[0];
//       fetchAttendance(formatted);
//     }
//   }, [selectedDate]);
 
//   if (loading) {
//     return (
//       <div className="p-6 text-center text-gray-400">
//         Loading attendance...
//       </div>
//     );
//   }
 
//   const getTotalMinutes = (row) => row.total_minutes || 0;
//   const getBreakMinutes = (row) => row.break_minutes || 0;
 
//   const getPunchInSeconds = (time) => {
//     if (!time) return 0;
//     const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
//     return h * 3600 + m * 60 + s;
//   };
 
//   const sortedRecords = [...records].sort((a, b) => {
 
//     if (!sortBy) {
//       return (a.name || "")
//         .toLowerCase()
//         .localeCompare((b.name || "").toLowerCase());
//     }
 
//     let result = 0;
 
//     if (sortBy === "HOURS") {
//       result = getTotalMinutes(b) - getTotalMinutes(a);
//     }
 
//     if (sortBy === "BREAK") {
//       result = getBreakMinutes(b) - getBreakMinutes(a);
//     }
 
//     if (sortBy === "LATE") {
//       result = getPunchInSeconds(a.punch_in) - getPunchInSeconds(b.punch_in);
//     }
 
//     if (result === 0) {
//       return (a.name || "")
//         .toLowerCase()
//         .localeCompare((b.name || "").toLowerCase());
//     }
 
//     return result;
//   });
 
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
 
//   const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);
 
//   return (
//     <>
 
          
//           <div className="max-w-7xl mx-auto md:mt-8 mt-6">
//       <div className="
//         relative
//         overflow-hidden
//         rounded-[30px]
//         p-8
//         bg-gradient-to-br from-[#2a1a5e] via-[#1b1445] to-[#0e0a2c] shadow-[0_20px_60px_rgba(0,0,0,0.6)]
//         text-white
//         border border-white/10
//         shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
//       ">
          
//           {/* HEADER */}
 
//           <div className="flex flex-wrap items-center justify-between mb-6 gap-2 md:gap-4">
 
//             <h2 className="text-white text-lg font-semibold ">
//               All Users Attendance ({selectedDate?.toISOString().split("T")[0]})
//             </h2>
 
//             {/* <div className="flex flex-col md:flex-row items-center gap-3"> */}
 
//               <select
//                 value={sortBy}
//                 onChange={(e) => setSortBy(e.target.value)}
//                 className="
//                  px-2 py-1 text-sm rounded-[10px]
//                 bg-white/10 text-white
//                 border border-white/20
//                 shadow-lg focus:outline-none
//                 backdrop-blur-md outline-none
//                 cursor-pointer
//                 "
//               >
//                 <option className="text-black" value="">Sort By</option>
//                 <option className="text-black" value="HOURS">Total Working Hours</option>
//                 <option className="text-black" value="BREAK">Total Break Duration</option>
//                 <option className="text-black" value="LATE">Punch-In Time</option>
//               </select>



//               <div className="flex flex-row md:flex-row items-center gap-3">

//               <DatePicker
//                 selected={selectedDate}
//                 onChange={(date) => setSelectedDate(date)}
//                 dateFormat="yyyy-MM-dd"
//                 className=" px-2  py-1 text-sm rounded-[10px]
//                 bg-white/10 text-white
//                 border border-white/20
//                 shadow-lg focus:outline-none
//                 backdrop-blur-md outline-none
//                 cursor-pointer"
//               />
 
//               <button
//                 onClick={() => setSelectedDate(new Date())}
//                 className="bg-white/10 text-white  px-2  py-1 text-sm rounded-[10px] border border-white/10   hover:bg-white/20 transition"
//               >
//                 Reset
//               </button>
 
//             </div>
//           </div>
 
//           {/* TABLE */}
 
//           <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl">
//             <table className="min-w-[900px] w-full text-sm text-white">
 
//               <thead>
//                 <tr className="text-xs uppercase tracking-wider text-gray-300 border-b border-white/10">
//                   <th className="p-4 text-left">Name</th>
//                   <th className="p-4 text-left">Punch In</th>
//                   <th className="p-4 text-left">Image In</th>
//                   <th className="p-4 text-left">Image Out</th>
//                   <th className="p-4 text-left">Punch Out</th>
//                   <th className="p-4 text-left">Total Hours</th>
//                   <th className="p-4 text-left">Break</th>
//                   <th className="p-4 text-left">Status</th>
//                   <th className="p-4 text-left">Early / Extra</th>
//                 </tr>
//               </thead>
 
//               <tbody>
 
//                 {records.length > 0 ? (
 
//                   currentRecords.map((row, i) => (
 
//                     <tr
//                       key={row.user_id || i}
//                       className="border-b border-white/5 hover:bg-white/10 transition"
//                     >
 
//                       {/* NAME */}
 
//                       <td className="p-4 whitespace-nowrap">
 
//                         <div
//                           className="flex items-center gap-3 cursor-pointer"
//                           onClick={() => navigate(`/users/${row.user_id}`)}
//                         >
 
//                           <div className="w-9 h-9 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-white font-semibold">
 
//                             {row.profile_pic ? (
//                               <img
//                                 src={`${IMAGE_BASE_URL}${row.profile_pic}`}
//                                 className="w-full h-full rounded-full object-cover"
//                                 alt="profile"
//                               />
//                             ) : (
//                               row.name?.charAt(0) || "U"
//                             )}
 
//                           </div>
 
//                           <p className="font-medium hover:text-cyan-400 hover:underline">
//                             {row.name || "—"}
//                           </p>
 
//                         </div>
 
//                       </td>
 
//                       <td className="p-4">{row.punch_in || "—"}</td>
 
//                       <td className="p-4">
//                         {row.punch_in_img ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
//                             className="w-10 h-10 rounded cursor-pointer"
//                             onClick={() =>
//                               setImagePreview(`${IMAGE_BASE_URL}/${row.punch_in_img}`)
//                             }
//                           />
//                         ) : "—"}
//                       </td>
 
//                       <td className="p-4">
//                         {row.punch_out_img ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
//                             className="w-10 h-10 rounded cursor-pointer"
//                             onClick={() =>
//                               setImagePreview(`${IMAGE_BASE_URL}/${row.punch_out_img}`)
//                             }
//                           />
//                         ) : "—"}
//                       </td>
 
//                       <td className="p-4">{row.punch_out || "—"}</td>
 
//                       <td className="p-4">
 
//                         {row.total_minutes
//                           ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
//                           : "—"}
 
//                       </td>
 
//                       {/* <td className="p-4">
 
//                         {Number(row.break_minutes) === 0
//                           ? <span className="text-gray-400">Not taken</span>
//                           : `${row.break_minutes}m`}
 
//                       </td> */}
 
 
// <td className="p-4">
 
//   {row.break_status === 1 ? (
//     <span className="text-yellow-400 font-medium">
//       On Break
//     </span>
//   ) : Number(row.break_minutes) === 0 ? (
//     <span className="text-gray-400">Not taken</span>
//   ) : (
//     `${row.break_minutes}m`
//   )}
 
// </td>
 
 
 
//                       <td className="p-4">
 
//                         <span
//                           className={`px-3 py-1 rounded-full text-xs font-medium flex items-center w-fit
//                           ${row.status
//                               ? "bg-emerald-500/20 text-emerald-400"
//                               : "bg-red-500/20 text-red-400"
//                             }`}
//                         >
//                           {row.status ? "Present" : "Absent"}
//                         </span>
 
//                       </td>
 
//                       <td className="p-4 text-xs">
 
//                         Early: {row.early_time || "0m"} <br />
//                         Extra: {row.extra_time || "0m"}
 
//                       </td>

//                     </tr>
 
//                   ))
 
//                 ) : (
 
//                   <tr>
//                     <td colSpan="10" className="text-center p-6 text-gray-400">
//                       No Attendance Records Found
//                     </td>
//                   </tr>
 
//                 )}
 
//               </tbody>
//             </table>
//           </div>
 
//           {/* PAGINATION */}
 
//           {totalPages > 1 && (
//             <div className="flex justify-center mt-6 items-center gap-4">
//               <button
//                 onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
//                 disabled={currentPage === 1}
//                 className="px-4 py-2 rounded-xl text-sm transition bg-white/10 text-white hover:bg-white/20 disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Prev
//               </button>
//               <span className="text-sm text-white/90 font-medium">
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
//                  disabled={currentPage === totalPages}
//                  className="px-4 py-2 rounded-xl text-sm transition bg-white/10 text-white hover:bg-white/20 disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Next
//               </button>
//             </div>
//           )}
 
//         </div>
//       </div>
 
//       {/* IMAGE MODAL */}
 
//       {imagePreview && (
 
//         <div
//           className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
//           onClick={() => setImagePreview(null)}
//         >
 
//           <div className="bg-white p-4 rounded-xl">
//             <img src={imagePreview} className="max-h-[80vh]" />
//           </div>
 
//         </div>
 
//       )}
 
//     </>
//   );
// }


// import { useEffect, useState } from "react";
// import { adminDailyAttendanceApi } from "../../../app/api";
// import { useNavigate } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// export default function MyAttendance() {

//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [currentPage, setCurrentPage] = useState(1);
//   const recordsPerPage = 5;

//   const [sortBy, setSortBy] = useState("");
//   const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
//   const navigate = useNavigate();

//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imagePreview, setImagePreview] = useState(null);

//   const fetchAttendance = (date) => {
//     setLoading(true);

//     adminDailyAttendanceApi(date)
//       .then((res) => {
//         if (res?.success && Array.isArray(res.data)) {
//           setRecords(res.data);
//         } else {
//           setRecords([]);
//         }
//       })
//       .catch(() => setRecords([]))
//       .finally(() => setLoading(false));
//   };

//   useEffect(() => {
//     if (selectedDate) {
//       const formatted = selectedDate.toISOString().split("T")[0];
//       fetchAttendance(formatted);
//     }
//   }, [selectedDate]);

//   if (loading) {
//     return (
//       <div className="p-6 text-center text-gray-400">
//         Loading attendance...
//       </div>
//     );
//   }

//   const getTotalMinutes = (row) => row.total_minutes || 0;
//   const getBreakMinutes = (row) => row.break_minutes || 0;

//   const getPunchInSeconds = (time) => {
//     if (!time) return 0;
//     const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
//     return h * 3600 + m * 60 + s;
//   };

//   const sortedRecords = [...records].sort((a, b) => {

//     if (!sortBy) {
//       return (a.name || "")
//         .toLowerCase()
//         .localeCompare((b.name || "").toLowerCase());
//     }

//     let result = 0;

//     if (sortBy === "HOURS") {
//       result = getTotalMinutes(b) - getTotalMinutes(a);
//     }

//     if (sortBy === "BREAK") {
//       result = getBreakMinutes(b) - getBreakMinutes(a);
//     }

//     if (sortBy === "LATE") {
//       result = getPunchInSeconds(a.punch_in) - getPunchInSeconds(b.punch_in);
//     }

//     if (result === 0) {
//       return (a.name || "")
//         .toLowerCase()
//         .localeCompare((b.name || "").toLowerCase());
//     }

//     return result;
//   });

//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);

//   const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);

//   return (
//     <>
//       <div className="px-6 py-6 flex justify-center">
//         <div className="w-full max-w-7xl rounded-3xl bg-gradient-to-br from-[#2a1a5e] via-[#1b1445] to-[#0e0a2c] shadow-[0_20px_60px_rgba(0,0,0,0.6)] p-6">

//           {/* HEADER */}

//           <div className="flex flex-wrap items-center justify-between mb-6 gap-4">

//             <h2 className="text-white text-lg font-semibold">
//               All Users Attendance ({selectedDate?.toISOString().split("T")[0]})
//             </h2>

//             <div className="flex items-center gap-3">

//               <select
//                 value={sortBy}
//                 onChange={(e) => setSortBy(e.target.value)}
//                 className="bg-white/10 text-white border border-white/10 rounded-xl px-3 py-2 text-sm backdrop-blur focus:outline-none"
//               >
//                 <option value="">Sort By</option>
//                 <option value="HOURS">Total Working Hours</option>
//                 <option value="BREAK">Total Break Duration</option>
//                 <option value="LATE">Punch-In Time</option>
//               </select>

//               <DatePicker
//                 selected={selectedDate}
//                 onChange={(date) => setSelectedDate(date)}
//                 dateFormat="yyyy-MM-dd"
//                 className="bg-white/10 text-white border border-white/10 rounded-xl px-3 py-2 text-sm backdrop-blur cursor-pointer"
//               />

//               <button
//                 onClick={() => setSelectedDate(new Date())}
//                 className="bg-white/10 text-white px-3 py-2 rounded-xl hover:bg-white/20 transition"
//               >
//                 Reset
//               </button>

//             </div>
//           </div>

//           {/* TABLE */}

//           <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl">
//             <table className="min-w-[900px] w-full text-sm text-white">

//               <thead>
//                 <tr className="text-xs uppercase tracking-wider text-gray-300 border-b border-white/10">
//                   <th className="p-4 text-left">Name</th>
//                   <th className="p-4 text-left">Punch In</th>
//                   <th className="p-4 text-left">Image In</th>
//                   <th className="p-4 text-left">Image Out</th>
//                   <th className="p-4 text-left">Punch Out</th>
//                   <th className="p-4 text-left">Total Hours</th>
//                   <th className="p-4 text-left">Break</th>
//                   <th className="p-4 text-left">Status</th>
//                   <th className="p-4 text-left">Early / Extra</th>
//                 </tr>
//               </thead>

//               <tbody>

//                 {records.length > 0 ? (

//                   currentRecords.map((row, i) => (

//                     <tr
//                       key={row.user_id || i}
//                       className="border-b border-white/5 hover:bg-white/10 transition"
//                     >

//                       {/* NAME */}

//                       <td className="p-4 whitespace-nowrap">

//                         <div
//                           className="flex items-center gap-3 cursor-pointer"
//                           onClick={() => navigate(`/users/${row.user_id}`)}
//                         >

//                           <div className="w-9 h-9 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-white font-semibold">

//                             {row.profile_pic ? (
//                               <img
//                                 src={`${IMAGE_BASE_URL}${row.profile_pic}`}
//                                 className="w-full h-full rounded-full object-cover"
//                                 alt="profile"
//                               />
//                             ) : (
//                               row.name?.charAt(0) || "U"
//                             )}

//                           </div>

//                           <p className="font-medium hover:text-cyan-400 hover:underline">
//                             {row.name || "—"}
//                           </p>

//                         </div>

//                       </td>

//                       <td className="p-4">{row.punch_in || "—"}</td>

//                       <td className="p-4">
//                         {row.punch_in_img ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
//                             className="w-10 h-10 rounded cursor-pointer"
//                             onClick={() =>
//                               setImagePreview(`${IMAGE_BASE_URL}/${row.punch_in_img}`)
//                             }
//                           />
//                         ) : "—"}
//                       </td>

//                       <td className="p-4">
//                         {row.punch_out_img ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
//                             className="w-10 h-10 rounded cursor-pointer"
//                             onClick={() =>
//                               setImagePreview(`${IMAGE_BASE_URL}/${row.punch_out_img}`)
//                             }
//                           />
//                         ) : "—"}
//                       </td>

//                       <td className="p-4">{row.punch_out || "—"}</td>

//                       <td className="p-4">

//                         {row.total_minutes
//                           ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
//                           : "—"}

//                       </td>

//                       {/* <td className="p-4">

//                         {Number(row.break_minutes) === 0
//                           ? <span className="text-gray-400">Not taken</span>
//                           : `${row.break_minutes}m`}

//                       </td> */}


// <td className="p-4">

//   {row.break_status === 1 ? (
//     <span className="text-yellow-400 font-medium">
//       On Break
//     </span>
//   ) : Number(row.break_minutes) === 0 ? (
//     <span className="text-gray-400">Not taken</span>
//   ) : (
//     `${row.break_minutes}m`
//   )}

// </td>



//                       <td className="p-4">

//                         <span
//                           className={`px-3 py-1 rounded-full text-xs font-medium flex items-center w-fit
//                           ${row.status
//                               ? "bg-emerald-500/20 text-emerald-400"
//                               : "bg-red-500/20 text-red-400"
//                             }`}
//                         >
//                           {row.status ? "Present" : "Absent"}
//                         </span>

//                       </td>

//                       <td className="p-4 text-xs">

//                         Early: {row.early_time || "0m"} <br />
//                         Extra: {row.extra_time || "0m"}

//                       </td>

//                     </tr>

//                   ))

//                 ) : (

//                   <tr>
//                     <td colSpan="10" className="text-center p-6 text-gray-400">
//                       No Attendance Records Found
//                     </td>
//                   </tr>

//                 )}

//               </tbody>
//             </table>
//           </div>

//           {/* PAGINATION */}

//           {totalPages > 1 && (

//             <div className="flex justify-center mt-6 gap-2">

//               {Array.from({ length: totalPages }, (_, i) => (

//                 <button
//                   key={i}
//                   onClick={() => setCurrentPage(i + 1)}
//                   className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm transition
//                   ${currentPage === i + 1
//                       ? "bg-gradient-to-r from-pink-500 to-purple-500 text-white"
//                       : "bg-white/10 text-white hover:bg-white/20"
//                     }`}
//                 >
//                   {i + 1}
//                 </button>

//               ))}

//             </div>

//           )}

//         </div>
//       </div>

//       {/* IMAGE MODAL */}

//       {imagePreview && (

//         <div
//           className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
//           onClick={() => setImagePreview(null)}
//         >

//           <div className="bg-white p-4 rounded-xl">
//             <img src={imagePreview} className="max-h-[80vh]" />
//           </div>

//         </div>

//       )}

//     </>
//   );
// }

